const GUIDDE_SHARE_REGEX =
  /https?:\/\/app\.guidde\.com\/share\/playbooks\/([A-Za-z0-9_-]+)(?:\?[^\s]*)?/gi;

const GUIDDE_EMBED_REGEX =
  /https?:\/\/embed\.app\.guidde\.com\/playbooks\/([A-Za-z0-9_-]+)(?:\?[^\s]*)?/gi;

export function extractGuiddeVideoUrl(text = "") {
  const value = String(text || "");
  const shareMatch = value.match(
    /https?:\/\/app\.guidde\.com\/share\/playbooks\/([A-Za-z0-9_-]+)/i,
  );
  if (shareMatch?.[1]) {
    return `https://app.guidde.com/share/playbooks/${shareMatch[1]}`;
  }
  const embedMatch = value.match(
    /https?:\/\/embed\.app\.guidde\.com\/playbooks\/([A-Za-z0-9_-]+)/i,
  );
  if (embedMatch?.[1]) {
    return `https://app.guidde.com/share/playbooks/${embedMatch[1]}`;
  }
  return null;
}

export function toGuiddeEmbedUrl(shareOrEmbedUrl) {
  const id = extractGuiddePlaybookId(shareOrEmbedUrl);
  if (!id) return null;
  return `https://embed.app.guidde.com/playbooks/${id}`;
}

function extractGuiddePlaybookId(url = "") {
  const value = String(url || "");
  const match =
    value.match(/\/playbooks\/([A-Za-z0-9_-]+)/i) ||
    value.match(/playbooks\/([A-Za-z0-9_-]+)/i);
  return match?.[1] || null;
}

export function stripGuiddeUrls(text = "") {
  return String(text || "")
    .replace(GUIDDE_SHARE_REGEX, "")
    .replace(GUIDDE_EMBED_REGEX, "")
    .replace(/\s{2,}/g, " ")
    .trim();
}

export function resolveFaqVideo(faq = {}) {
  const shareUrl =
    faq.videoLink ||
    faq.videoUrl ||
    faq.video ||
    extractGuiddeVideoUrl(faq.answer) ||
    null;
  const embedUrl = shareUrl ? toGuiddeEmbedUrl(shareUrl) : null;
  const rawAnswer = faq.answer || "";
  // Keep HTML answers untouched so Quill/editor markup renders as saved.
  const isHtml = /<\/?[a-z][\s\S]*>/i.test(rawAnswer);
  return {
    shareUrl,
    embedUrl,
    displayAnswer:
      embedUrl && !isHtml ? stripGuiddeUrls(rawAnswer) : rawAnswer,
  };
}
